// extracted by mini-css-extract-plugin
export default {"form":"WeatherMain_form__Q6tW2","loading":"WeatherMain_loading__8BZAv","control":"WeatherMain_control__HIfdT","actions":"WeatherMain_actions__Jk4EE"};